import { useEffect, useState } from "react";
import { useGetDriversBasicQuery } from "@api/graphql/generated/generated-types";
import { makeDriverOptions } from "@src/shipments/utils/makeDriverOptions";
import { DriverSelectOption } from "@src/common/components/DriverSelect/DriverSelect";
import { DRIVER_API_LIMIT } from "@src/common/constants/apiConstants";
import { useErrorToast } from "./useErrorToast";

interface UseDriverOptionsProps {
  courierId: string | null | undefined;
}

export const useDriverOptions = ({ courierId }: UseDriverOptionsProps) => {
  const [driverOptions, setDriverOptions] = useState<DriverSelectOption[]>([]);
  const showError = useErrorToast();

  const { data, loading, error } = useGetDriversBasicQuery({
    variables: {
      courierId: courierId!,
      limit: DRIVER_API_LIMIT,
    },
    skip: !courierId,
    onError: showError,
  });

  // Process driver data when it's loaded
  useEffect(() => {
    if (!data?.drivers?.edges) return;

    const allDrivers = makeDriverOptions((data.drivers.edges as any) || []);
    const driverSelectOptions: DriverSelectOption[] = allDrivers
      .map((driver) => ({
        label: driver.name,
        value: driver.id,
        driver: driver.driver,
        photoUrl: driver.url,
        avatarDisplay: driver.driver?.avatarDisplay || undefined,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    setDriverOptions(driverSelectOptions);
  }, [data]);

  return {
    driverOptions,
    loading,
    error,
  };
};
